import { MEDIA_UNIT_AVAILABILITY_KEY_PREFIX } from '../../../reservations/api/queries';

export function mediaUnitDetailQueryKey(id: string | number) {
  return ['media-units', String(id)] as const;
}

export function mediaUnitAvailabilityQueryKey(unitIds: number[], from: string, to: string) {
  return [
    ...MEDIA_UNIT_AVAILABILITY_KEY_PREFIX,
    unitIds.slice().sort((a, b) => a - b),
    from,
    to,
  ] as const;
}

export function mediaUnitListsQueryKey() {
  return ['media-units', 'list'] as const;
}
